import { localStorageService } from './local-storage-service';

export const accessTokenService = localStorageService('access_token');
